import { DatePicker, Input, Modal, Select } from '@bitcine/cinesend-theme/dist'
import { useQueryClient, useQuery } from '@tanstack/react-query'
import { useState } from 'react'
import useStore from '../../hooks/use_store'

const EditModal = ({ onClose, disabled, cycle, invalidateKey }) => {
  const queryClient = useQueryClient()
  const { data: schemas } = useQuery(['/api/schemas'])
  const { updateModel } = useStore()
  const [state, setState] = useState(cycle)

  const update = (data) => {
    setState({ ...state, ...data })
  }

  const saveCycleData = () => {
    updateModel.mutate(
      {
        endpoint: 'cycles',
        id: cycle.id,
        data: state,
      },
      {
        onSuccess: () => queryClient.setQueryData(['cycles/', cycle.id], { ...state }),
        onError: (err) => console.log(err),
        onSettled: () => {
          queryClient.invalidateQueries([invalidateKey])
          onClose()
        },
      }
    )
  }

  const schemasToOptions = schemas?.map((schema) => ({ value: schema.id, label: schema.name })) ?? []

  return (
    <Modal
      header={`Edit cycle`}
      onClose={onClose}
      confirmButton={{
        disabled: updateModel.isLoading,
        text: 'Save',
        onClick: () => saveCycleData(),
      }}
    >
      <div className={'max-h-96'}>
        <p className='pb-4'>{cycle.description}</p>
        <Input
          label={`Name`}
          value={state.name}
          onChange={(e) => update({ name: e.target.value })}
          placeholder={`Enter new name here...`}
          autoFocus
        />
        <DatePicker
          useLocal={false}
          label={'Start Date'}
          className='w-full'
          date={state.start_date}
          showTimeSelect={false}
          onChange={(newDate) => update({ start_date: newDate }, false)}
        />
        <DatePicker
          useLocal={false}
          label={'End Date'}
          className='w-full'
          date={state.end_date}
          showTimeSelect={false}
          onChange={(newDate) => update({ end_date: newDate }, false)}
        />
        <Select
          label={'Schema'}
          placeholder='Select Schema'
          options={schemasToOptions}
          value={schemasToOptions?.find((option) => option.value === state.schema_id)}
          isMulti={false}
          onChange={(schema) => {
            update({ schema_id: schema.value })
          }}
          disabled={disabled}
        />
      </div>
    </Modal>
  )
}

export default EditModal
